import {useListDepartmentsQuery} from "../../apis/departmentApi";
import {useMemo} from "react";
import OrganizationalIndexTreeCard from "./OrganizationalIndexTreeCard";
import {Tree, TreeNode} from "react-organizational-chart";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";

const OrganizationalIndexTreeView = () => {
    const {data: departments, isFetching} = useListDepartmentsQuery(true);
    const navigate = useNavigate();

    const treeView = useMemo(() => {
        if(isFetching) return (<></>);

        const parentDepartment = (departments || []).find(department => department.parent === '');

        if(!parentDepartment) return (<><Button type="button" label="Create Organizational Index" icon="pi pi-plus" onClick={() => navigate(`/company-admin/organizational-index/edit/new`)} /></>);

        const renderChildren = (department) => {
            const children = departments.filter(testDep => testDep.parent === department.id);

            if(!children.length) return undefined;

            return (
                <>{children.map(child => (<TreeNode key={child.id} label={<OrganizationalIndexTreeCard department={child} />}>
                    {renderChildren(child)}
                </TreeNode>))}</>
            )
        }

        return (<Tree label={<OrganizationalIndexTreeCard department={parentDepartment} />}>
            {renderChildren(parentDepartment)}
            </Tree>);
    }, [departments, isFetching, navigate]);

    return (<div className="mobile-horizontal-scrollable"><div className="organization-index-tree-view">{treeView}</div></div>);
}

export default OrganizationalIndexTreeView;
